export { Iframe } from "./Iframe"
export type { IframeProps } from "./Iframe"
